export default function getFilteredLocations(allLocations, groupName, groupItems) {
  const ids = new Set(groupItems.map((g) => g.id));
  if (groupName === "Division") return allLocations.filter((l) => ids.has(l.division_id));
  if (groupName === "District") return allLocations.filter((l) => ids.has(l.district_id));
  if (groupName === "Region") return allLocations.filter((l) => ids.has(l.region_id));
  return allLocations;
}
